const googleAPIKeys = {
  convrrtV1: 'AIzaSyCJLgIZIqQK7gwMM941IcCH4c5jwnLwC14',
  convrrtV3: 'AIzaSyCTi9wYI4qK9aKjRRvk1rgymqfZPTTOgjA'
}

export default {
  namespaced: true,
  state: {
    googleApiKey: googleAPIKeys.convrrtV3,
    firebase: {
      convrrtV1: {
        apiKey: googleAPIKeys.convrrtV1,
        authDomain: 'convrrt-1081.firebaseapp.com',
        databaseURL: 'https://convrrt-1081.firebaseio.com',
        projectId: 'convrrt-1081',
        storageBucket: 'convrrt-1081.appspot.com',
        messagingSenderId: '530218935106'
      },
      convrrtV3: {
        apiKey: googleAPIKeys.convrrtV3,
        authDomain: 'convrrt-v3.firebaseapp.com',
        databaseURL: 'https://convrrt-v3.firebaseio.com',
        projectId: 'convrrt-v3',
        storageBucket: 'convrrt-v3.appspot.com',
        messagingSenderId: '1063982133056'
      }
    }
  }
}
